import { LocationType } from '../../types';

export interface LocationTypeConfig {
  value: LocationType;
  label: string;
  icon: string;
  color: string;
}

// Base configuration without labels (labels will be provided by translation function)
const LOCATION_TYPE_BASE_CONFIG: Array<{value: LocationType; icon: string; color: string}> = [
  { value: 'vacation', icon: '🏖️', color: '#ff6b6b' },
  { value: 'party', icon: '🎉', color: '#a29bfe' },
  { value: 'work', icon: '💼', color: '#74b9ff' },
  { value: 'other', icon: '📍', color: '#636e72' },
];

// Function to get location types with translated labels
export const getLocationTypes = (t: (key: string) => string): LocationTypeConfig[] => {
  return LOCATION_TYPE_BASE_CONFIG.map(config => ({
    ...config,
    label: t(`map.locationTypes.${config.value}`)
  }));
};

export const getLocationTypeConfig = (type: LocationType, t: (key: string) => string): LocationTypeConfig => {
  const types = getLocationTypes(t);
  return types.find(lt => lt.value === type) || types[3]; // Default to 'other'
};
